<app-bread-crumbs *ngIf="!isLoading" [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage" [clickHandler]="handleBackButton"
  [userRoleOnRfqSummary]="userRoleOnRfqSummary" [canRecallRFQSummary]="canRecallRFQSummary" (buttonActionHandler)="breadcrumbsButtonActionHandler($event)">
</app-bread-crumbs>
<div class="page-container">
  <div class="mt-2 mb-4 alert-padding">
    <shared-alert [type]="alertType.Error" *ngIf="isSourcingOutcomeHasError || isVendorDocumentHasError">
      <p alert-content class="my-2">Please correct the following errors in Sourcing Outcome tab:
        <ng-container *ngIf="isSourcingOutcomeHasError">
          <div class="paragraph-medium-bold">Sourcing outcome</div>
          <ul>
            <li>Please provide the quote expiry date or reason for no quotation for each vendor</li>
          </ul>
        </ng-container>
        <ng-container *ngIf="isVendorDocumentHasError">
          <div class="paragraph-medium-bold">Vendor documents</div>
          <ul>
            <li>Please provide the quote expiry date or reason for no quotation for each vendor</li>
          </ul>
        </ng-container>
      </p>
    </shared-alert>
    <shared-alert [type]="alertType.Warning" *ngIf="!isLoading && vendorsHavingExpiredQuote.length > 0">
      <div alert-content class="my-1">
        <ng-container>
          <span>Please note that quote from the following Vendors have expired:
            <ul>
              <li *ngFor="let vendor of vendorsHavingExpiredQuote">{{ vendor }}</li>
            </ul>
            <span *ngIf="userRoleOnRfqSummary===RFQSummaryRole.RO">Please work with the assigned PE to obtain revised
              quotes.</span>
          </span>
        </ng-container>
      </div>
    </shared-alert>
    <shared-alert [type]="alertType.Info" [showClose]="true" oneTimeOnlyKey="rfq-summary-initial-info">
      <div alert-content class="my-1">
        <ng-container>
          <span>Please complete the following:
            <ul class="rfq-summary-info-list">
              <li *ngFor="let msg of getInfoList()">{{msg}}</li>
            </ul>
          </span>
        </ng-container>
      </div>
    </shared-alert>
  </div>
  <app-layout class="container--form">
    <app-loader [isLoading]="isLoading"></app-loader>
    <div *ngIf="!isLoading">
      <div class="form-header-new-container">
        <div class="form-header-group-container">
          <div>
            <label for="field1" class="paragraph-medium-regular">RFQ Summary no:</label>
            <span *ngIf="statusData.rfqSummaryNum===''" id="field1" class="paragraph-medium-regular"
              style="color:#87898C">To be Generated</span>
            <span *ngIf="statusData.rfqSummaryNum!==''" id="field1"
              class="paragraph-medium-bold">{{statusData.rfqSummaryNum}}</span>
          </div>
          <div>
            <label for="field4" class="paragraph-medium-regular">RFQ no:</label>
            <span id="field4" class="paragraph-medium-bold">{{statusData.rfqNum}}</span>
          </div>
          <div>
            <label for="field7" class="paragraph-medium-regular">MP Document no:</label>
            <span id="field7" class="link paragraph-medium-bold"
              (click)="navigateToDocument()">{{statusData.documentNo}}</span>
          </div>
        </div>
        <div class="form-header-group-container wider-label">
          <div>
            <label for="field2" class="paragraph-medium-regular">Assigned PE:</label>
            <span id="field2" class="paragraph-medium-bold">{{statusData.assignedPE}}</span>
          </div>
          <div>
            <label for="field5" class="paragraph-medium-regular">Requesting officer:</label>
            <span id="field5" class="paragraph-medium-bold">{{statusData.requestingOfficer}}</span>
          </div>
          <div>
            <label for="field8" class="paragraph-medium-regular">Security Classification in PO:</label>
            <span id="field8" class="paragraph-medium-bold">{{statusData.SecurityClassIdExt}}</span>
          </div>
        </div>
        <div class="form-header-group-container">
          <div>
            <label for="field3" class="paragraph-medium-regular">Document status:</label>
            <span id="field3" class="paragraph-medium-bold">{{statusData.status}}</span>
          </div>
          <div>
            <label for="field6" class="paragraph-medium-regular">Created By:</label>
            <span id="field6" class="paragraph-medium-bold">{{statusData.createdBy}}</span>
          </div>
          <div>
            <label for="field9" class="paragraph-medium-regular">Created on:</label>
            <span id="field9" class="paragraph-medium-bold">{{statusData.submittedOn| date: 'dd/MM/yyyy'}}</span>
          </div>
        </div>
      </div>
    </div>
    <mat-tab-group dynamicHeight mat-stretch-tabs="false" mat-align-tabs="start" *ngIf="!isLoading">
      <mat-tab label="Sourcing Outcome">
        <div>
          <app-sourcing-outcome [vendorList]="vendorList" [reasonForNoQuotation]="reasonForNoQuotation"
            [isReadOnlyRFQSummary]="isReadOnlyRFQSummary"></app-sourcing-outcome>
          <app-vendor-documents [vendorList]="vendorList" [statusData]="statusData" [user]="user" [userList]="userList"
            [isReadOnlyRFQSummary]="isReadOnlyRFQSummary"></app-vendor-documents>
        </div>
      </mat-tab>
      <mat-tab label="Items">
        <div>
          <app-items-list [statusData]="statusData" [list]="rfqItems" [userRoleOnRfqSummary]="userRoleOnRfqSummary"
            [mpMmsInformation]="mpMmsInformation" (allItemsHavePoChange)="updateAllItemsHavePO($event)" (onRaisePO)="handleRaisePO($event)" [isReadOnlyRFQSummary]="isReadOnlyRFQSummary"></app-items-list>
        </div>
      </mat-tab>
    </mat-tab-group>
  </app-layout>
</div>